import React, { FunctionComponent } from 'react'
import { EventDetailInfoProps } from './types'

export const Presentation: FunctionComponent<EventDetailInfoProps> = ({ title, locations, requirement }) => {
  return (
    <table className="article-section-table">
      <thead className="article-section-table-event">
        <tr>
          <th colSpan={2}>イベント情報</th>
        </tr>
      </thead>
      <tbody className="article-section-table-body">
        <tr className="article-section-table-line">
          <td className="article-section-table-category">イベント名</td>
          <td className="article-section-table-content">{title}</td>
        </tr>
        <tr>
          <td className="article-section-table-category">開催エリア</td>
          <td className="article-section-table-content">{locations}</td>
        </tr>
        <tr>
          <td className="article-section-table-category">持ち物</td>
          <td className="article-section-table-content">{requirement || '特になし'}</td>
        </tr>
      </tbody>
    </table>
  )
}
